import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import netlifyIdentity from 'netlify-identity-widget';

const root = ReactDOM.createRoot(document.getElementById('root'));
netlifyIdentity.init({
  //container: '#...' needed?
  APIUrl: 'https://dg-rating-tracker.netlify.app/.netlify/identity',
  namePlaceholder: 'John Doe',
  locale: 'en'
});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
